import drinkPuddle from "../../../model/actions/walk/drinkPuddle";
import leave from "../../../model/actions/leave";
/**
const getRandomDecision = () => {
  // Array of potential decisions
  const decisions = [
    { description: "Investigate shimmer", effect: "possibleWater" },
    { description: "Rest under shade", effect: "rest" },
    { description: "Continue walking", effect: "continue" },
    // ... other decisions
  ];

  const randomIndex = Math.floor(Math.random() * decisions.length);
  return decisions[randomIndex];
};
*/
const puddle = (onDone) => ({
  title: "puddle",
  description: [
    "there's something in the dust. a shimmer",
    "a shallow puddle lying still under the blazing sun",
  ],
  buttons: [drinkPuddle(onDone), leave(onDone)],
});

const decisions = [puddle];

const Walk = {
  random: () => {
    const randomIndex = Math.floor(Math.random() * decisions.length);
    return decisions[randomIndex];
  },
};

export default Walk;
